/* ============================================================================
   CircleDrops — Size guide modal controller (externalized)
   ----------------------------------------------------------------------------
   Save this file as:  assets/size-guide-modal.js
   Loaded from snippets/size-guide-modal.liquid with:
     <script src="{{ 'size-guide-modal.js' | asset_url }}" defer></script>

   The inline <script> this replaces had NO Liquid in it (the gender detection,
   the {% render %} charts and the default_gender classes are all in the markup,
   not the script), so this file is a verbatim copy with one addition: an
   install guard (window.__cdSizeGuideModalInit) so it initialises exactly once.
   Deferred, so it runs after the page is parsed; its own readyState check still
   fires initSizeGuide correctly.
   ============================================================================ */

(function () {
  'use strict';
  if (window.__cdSizeGuideModalInit) return;
  window.__cdSizeGuideModalInit = true;

  function activate(el, fn) {
    el.addEventListener('click', fn);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        fn(e);
      }
    });
  }

  function initSizeGuide() {
    var modal = document.getElementById('cd-size-guide-modal');
    if (!modal) return;

    /* ── Portal: move the modal to be a direct child of <body> ──
       A parent of this snippet (transform / filter / will-change) becomes
       the containing block for position:fixed and traps the modal inside
       that column. Relocating the node to <body> — like React's
       createPortal — lets it cover the whole viewport. CSS is class-based,
       so it still applies after the move. */
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    var scrollY = 0;

    function lockScroll() {
      scrollY = window.scrollY || document.documentElement.scrollTop;
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      if (sbw > 0) { document.body.style.paddingRight = sbw + 'px'; }
      document.body.style.overflow = 'hidden';
      /* iOS Safari: pin the body so it can't scroll behind the modal */
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockScroll() {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
    }

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      /* Tell the theme's sticky add-to-cart bar to hide itself while the
         modal is open — the bar uses z-index max-int, so it can't be
         out-stacked; this body class is its built-in hide hook. */
      document.body.classList.add('sg-modal-open');
      lockScroll();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sg-modal-open');
      unlockScroll();
    }

    /* Open triggers (anywhere on the page) */
    document.querySelectorAll('.cd-sg-open').forEach(function (btn) {
      activate(btn, function (e) { if (e) e.preventDefault(); openModal(); });
    });

    /* Close triggers (cross + overlay) */
    modal.querySelectorAll('[data-cd-sg-close]').forEach(function (el) {
      activate(el, closeModal);
    });

    /* Esc to close */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    /* Gender tabs */
    var tabs = modal.querySelectorAll('.cd-sg-tab');
    var panels = modal.querySelectorAll('.cd-sg-panel');
    tabs.forEach(function (tab) {
      activate(tab, function () {
        var g = tab.getAttribute('data-gender');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-gender') === g);
        });
      });
    });

    /* IN / CM unit toggle (global across both charts) */
    function setUnit(unit) {
      modal.querySelectorAll('.cd-sg-unit-btn').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-unit') === unit);
      });
      modal.querySelectorAll('.cd-sg-table').forEach(function (tbl) {
        tbl.hidden = (tbl.getAttribute('data-unit') !== unit);
      });
    }
    modal.querySelectorAll('.cd-sg-unit-btn').forEach(function (btn) {
      activate(btn, function () { setUnit(btn.getAttribute('data-unit')); });
    });
    setUnit('in'); /* default */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuide);
  } else {
    initSizeGuide();
  }
})();